export const THUMBNAIL_SIZE_1020 = 1020
